/* 🤖 this file was generated by svg-to-ts */
export const siriusDownloadSimple: {
  name: 'download_simple';
  data: string;
} = {
  name: 'download_simple',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M21 14.25v6a.75.75 0 0 1-.75.75H3.75a.75.75 0 0 1-.75-.75v-6a.75.75 0 1 1 1.5 0v5.25h15v-5.25a.75.75 0 1 1 1.5 0Zm-9.53.53a.747.747 0 0 0 1.06 0l3.75-3.75a.75.75 0 1 0-1.06-1.06l-2.47 2.47V3.75a.75.75 0 1 0-1.5 0v8.69L8.78 9.97a.75.75 0 0 0-1.06 1.06l3.75 3.75Z" fill="currentColor"/></svg>`
};
